import { tooltipPositoning } from "./tooltipPositioning.js";

//=====================================================================
// Hover Events Handler
//=====================================================================
export function tooltipHoverEvents(trigger, hoverCurrent, tooltipClasses, tooltip) {
    //const tooltip = document.querySelector('[data-tooltipContent]');
    let { tooltipPositionTop, tooltipPositionLeft } = tooltipPositoning(trigger, tooltip, tooltipClasses);
    if (hoverCurrent) {
        tooltip.setAttribute("aria-hidden", false)
        tooltip.style.transform = `translate(${tooltipPositionLeft}px, ${tooltipPositionTop}px)`
    } else {
        tooltip.remove();
    }
}



//=====================================================================
// Click Events Handler
//=====================================================================
export function tooltipClickEvents(trigger, tooltipClasses, tooltip) {
    // Display Block/Grid so the content attributes can be retrieved
    let { tooltipPositionTop, tooltipPositionLeft } = tooltipPositoning(trigger, tooltip, tooltipClasses);
    let tooltipVisible;
    tooltipVisible = "false";
    tooltip.style.transform = `translate(${tooltipPositionLeft}px, ${tooltipPositionTop}px)`
    tooltip.setAttribute("aria-hidden", tooltipVisible);
}

export function tooltipScrollEvents(trigger, tooltip, tooltipClasses) {
    let { tooltipPositionTop, tooltipPositionLeft } = tooltipPositoning(trigger, tooltip, tooltipClasses);
    tooltip.style.transform = `translate(${tooltipPositionLeft}px, ${tooltipPositionTop}px)`;
}
























// Click Events
//export function tooltipClickEvents(button, content) {
//    // Display the block so the width and height can be calculated
//    content.style.display = "block";
//    // Get the position from the top from popoverPositionCalculation()
//    const { tooltipPositionTop, tooltipPositionLeft } = tooltipPositoning(button, content);
//    content.style.transform = `translate(${tooltipPositionLeft}px, ${tooltipPositionTop}px)`
//}
//
//// Scroll Events
//export function tooltipScrollEvents(button, content) {
//    // Get the position from the top from popoverPositionCalculation()
//    const { tooltipPositionTop, tooltipPositionLeft } = tooltipPositoning(button, content);
//    // Style if the popup value changes
//    content.style.transform = `translate(${tooltipPositionLeft}px, ${tooltipPositionTop}px)`
//}
//
//// Resize Events
//export function tooltipResizeEvents(button, content) {
//    // Get the position from the top from popoverPositionCalculation()
//    const { tooltipPositionTop, tooltipPositionLeft } = tooltipPositoning(button, content);
//    // Style if the popup value changes
//    content.style.transform = `translate(${tooltipPositionLeft}px, ${tooltipPositionTop}px)`
//}